import React from 'react'
import { Link } from "react-router";

export default function Header() {
  return (
    <header>
      <Link to="/" className='page-title-container'>
        <h1 className='page-title'>ÁramlásSzimuláció.hu</h1>
      </Link>

      <nav className='nav-desktop'>
        <Link to="/about">Bemutatkozás</Link> 
        <Link to="/services">Szolgáltatások</Link>
        <Link to="/references">Referenciák </Link>
        <Link to="/contact">Kapcsolat</Link>
      </nav>

    </header>
  )
}
